import { getFullScreenImage } from '@gem/modules/image-resizer';
import { RemoteImage } from '@gem/modules/remote-storage';

import styles from './MediaGalleryImage.styles.m.css';

export const MediaGalleryImage = ({ payload }) => {
  return (
    <div className={styles.container}>
      <RemoteImage
        className={styles.image}
        src={getFullScreenImage(payload.url || payload.previewUrl)}
        alt=""
      />
    </div>
  );
};
